export default __webpack_public_path__ + "static/media/Bestseller_printing_rules_inches.1ece75c8.pdf";